import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { type Config } from '@/features/config/types'

// Keep all default config values here so they're not exposed anywhere
const generalCalendarBookingUrl = 'https://outlook.office365.com/owa/calendar/LetstalkaboutIndieBI@indiebi.com/bookings/'
const morePlatformsBookingUrlExtension = 's/mEy2OzbT3kySNLzGlRoO6g2'
const automationBookingUrlExtension = 's/VtaKKQkOfEaFpcNp5TgEmA2'
const unlockRevenueBookingUrlExtension = 's/yHqMClk-uES47IhpSi9mUw2'

const localConfig: Config = {
	generalCalendarBookingUrl,
	platformsUpsellCalendarBookingUrl: generalCalendarBookingUrl + morePlatformsBookingUrlExtension,
	automationUpsellCalendarBookingUrl: generalCalendarBookingUrl + automationBookingUrlExtension,
	unlockRevenueUpsellCalendarBookingUrl: generalCalendarBookingUrl + unlockRevenueBookingUrlExtension
}

const useConfigInnerStore = defineStore('configInner', () => {
	const config = ref<Config>(localConfig)

	return {
		config
	}
})

export const useConfigStore = defineStore('config', () => {
	const innerStore = useConfigInnerStore()
	const config = computed(() => innerStore.config)

	return {
		config
	}
})
